export default "__VITE_ASSET__CdfG_ZHt__"